export const dataSessionInfo = {
  type: 'object',
  required: ['DeviceSwaps'],
  properties: {
    SessionType: {
      type: ['null', 'string'],
    },
    DeviceSwaps: {
      type: 'number',
    },
  },
};
